// Roistat А/Б-тест нижней панели быстрых действий на мобильном (BackForm:
// звонок, Max, Telegram, ВК, корзина) — задача Битрикс24 №108346: панель
// закрывает низ экрана, проверяем, нужна ли она. В варианте hidden панели нет.
// Как и cart_no_install_button (utils/abTests.ts), тест программируемый:
// Roistat видит его по cookie roistat_ab. Отдельный файл — потому что
// abTests.ts серверный, а эта панель рисуется только в браузере.
// id = название теста в Roistat
const BACK_FORM_TEST = "mobile_bottom_panel";
const BACK_FORM_VARIANTS = ["old", "hidden"];
// На этой ширине BackForm — нижняя панель, шире — боковое меню, оно в тест не входит
const MOBILE_MAX_WIDTH = 991;

function getRoistatAbTests(): string[] {
  try {
    const match = document.cookie.match(/(?:^|; )roistat_ab=([^;]*)/);
    return match ? decodeURIComponent(match[1]).split(",").filter(Boolean) : [];
  } catch (e) {
    return [];
  }
}

/**
 * Инлайн-скрипт перед счётчиком Roistat: вариант должен оказаться в cookie
 * до загрузки счётчика, иначе визит попадёт в тест только со следующей полной
 * загрузки страницы. Заодно переносит roistat_ab со старой cookie на поддомене
 * на весь домен (.farkop.ru), как у cookie самого Roistat, — иначе при переходе
 * между поддоменами посетитель получал бы новый вариант.
 */
export const BACK_FORM_TEST_SCRIPT = `(function () {
  try {
    var tests = [];
    (document.cookie.match(/(?:^|; )roistat_ab=[^;]*/g) || []).forEach(function (cookie) {
      decodeURIComponent(cookie.split("=")[1]).split(",").forEach(function (test) {
        var id = test.split(":")[0];
        if (test && !tests.some(function (item) { return item.split(":")[0] === id; })) {
          tests.push(test);
        }
      });
    });
    var hasTest = tests.some(function (test) { return test.indexOf("${BACK_FORM_TEST}:") === 0; });
    if (!hasTest && window.innerWidth <= ${MOBILE_MAX_WIDTH}) {
      var variants = ${JSON.stringify(BACK_FORM_VARIANTS)};
      tests.push("${BACK_FORM_TEST}:" + variants[Math.floor(Math.random() * variants.length)]);
    }
    if (!tests.length) return;
    var parts = location.hostname.split(".");
    var domain = parts.length > 1 ? "; domain=." + parts.slice(-2).join(".") : "";
    document.cookie = "roistat_ab=; path=/; max-age=0";
    document.cookie = "roistat_ab=" + encodeURIComponent(tests.join(",")) +
      "; path=/; max-age=2592000; samesite=lax" + domain;
  } catch (e) {}
})();`;

export function isBackFormHidden() {
  if (typeof window === "undefined" || window.innerWidth > MOBILE_MAX_WIDTH) {
    return false;
  }
  return getRoistatAbTests().includes(`${BACK_FORM_TEST}:hidden`);
}
